<app-page-header title="Price Mismatch Report" subtitle="Monitor price accuracy and identify discrepancies"></app-page-header>

<div class="price-mismatch-container">
    <!-- Summary Cards -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
        <p-card styleClass="stat-card">
            <div class="stat-content">
                <div class="stat-icon total">
                    <i class="pi pi-list text-xl"></i>
                </div>
                <div class="stat-details">
                    <span class="stat-label">Total Number</span>
                    <span class="stat-value">{{ priceMismatchData()?.totalNumber ?? 0 }}</span>
                </div>
            </div>
        </p-card>

        <p-card styleClass="stat-card">
            <div class="stat-content">
                <div class="stat-icon match">
                    <i class="pi pi-check-circle text-xl"></i>
                </div>
                <div class="stat-details">
                    <span class="stat-label">Price Match</span>
                    <span class="stat-value">{{ priceMismatchData()?.priceMatchNumber ?? 0 }}</span>
                </div>
            </div>
        </p-card>

        <p-card styleClass="stat-card">
            <div class="stat-content">
                <div class="stat-icon mismatch">
                    <i class="pi pi-exclamation-circle text-xl"></i>
                </div>
                <div class="stat-details">
                    <span class="stat-label">Price Mismatch</span>
                    <span class="stat-value">{{ priceMismatchData()?.priceMismatchNumber ?? 0 }}</span>
                </div>
            </div>
        </p-card>
    </div>

    <!-- Charts Section -->
    <div class="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <!-- Bar Chart -->
        <p-card header="Match vs Mismatch Ratio by Agent" styleClass="chart-card lg:col-span-2">
            <p-chart type="bar" height="400px" [data]="barChartData()" [options]="barChartOptions"></p-chart>
        </p-card>

        <!-- Pie Chart -->
        <p-card header="Price Match Distribution" styleClass="chart-card">
            <div class="pie-chart-container">
                <p-chart type="pie" [data]="pieChartData()" [options]="pieChartOptions" height="300px"></p-chart>
            </div>
        </p-card>
    </div>
</div>
